import React from 'react';
import { toast } from 'react-toastify';

type Props = {
    callbackSearch: () => void;
    title?: string;
    loading?: boolean;
    locked?: boolean;
    message?: string;
};

const ButtonSearchFilter = ({
    callbackSearch,
    title = 'Buscar',
    locked = false,
    message = 'No se puede guardar este registro.'
}: Props) => {
    const showLockedMessage = () => {
        toast.error(message);
    };

    return !locked ? (
        <button
            type="button"
            className="waves-effect btn btn-primary btn-sm"
            onClick={locked ? showLockedMessage : callbackSearch}
        >
            <i className="fa fa-filter" /> {title}
        </button>
    ) : (
        <button type="button" className="waves-effect btn btn-primary btn-sm disabled">
            <i className="fa fa-filter" /> {title}
        </button>
    );
};

export default ButtonSearchFilter;
